// src/pages/HomePage.jsx

import React from 'react';
import HeroSection from '../components/HeroSection';
import FeaturesGrid from '../components/FeaturesGrid';
import Footer from '../components/Footer'; // ✅ Import the new Footer
import FeatureCarousel from '../components/FeatureCarousel';
import HowToGetStarted from '../components/HowToGetStarted';
import Navbar from '../components/Navbar';
import EnterSchoolId from '../components/EnterSchoolId';

const HomePage = () => {
  return (
    <div className="bg-gradient-to-br from-[#0f172a] via-[#1e293b] to-[#0f172a] text-white min-h-screen flex flex-col">
      <EnterSchoolId />
      <HeroSection />
      <FeaturesGrid />
      {/* <FeatureCarousel /> */}
      <HowToGetStarted />
      <Footer />
    </div>
  );
};

export default HomePage;
